import { useEffect } from "react";
import UserService from "../services/UserService";

const RenderOnAnonymous = () => {
  useEffect(() => {
    if (!UserService.isLoggedIn()) {
      UserService.doLogin();
    }
  }, []);

  return null;
};

export default RenderOnAnonymous;